import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import PiDialog from "../../components/PiDialog";
import ProjectSettingsBody from "./ProjectSettingsBody";

interface ProjectSettingsDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function ProjectSettingsDialog(props: ProjectSettingsDialogProps) {
  const { t } = useTranslation();

  return (
    <PiDialog
      open={props.open}
      onClose={props.onClose}
      width="420px"
      height="200px"
      hideCloseButton
      header={
        <div className="w-full flex items-center justify-between">
          <div className="text-[22px] font-semibold text-creator-text">
            {t("project_settings.title")}
          </div>
          <IconButton
            aria-label="project-settings-close-button"
            onClick={props.onClose}
            size="small"
            className="hover:bg-creator-primary-background"
          >
            <CloseIcon />
          </IconButton>
        </div>
      }
      body={
        <div className="flex flex-col py-1">
          <ProjectSettingsBody />
        </div>
      }
    />
  );
}
